<template>
  <div>
    <div :id="editorId" ></div>
  </div>
</template>

<script>
  import Vditor from 'vditor';
  import 'vditor/dist/index.css';

  export default {
    name: 'VditorComponent',
    props: {
      value: {
        type: String,
        default: '',
      },
      editorId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        vditor: null,
        newValue: '',
      };
    },
    watch: {
      newValue(newValue) {
        console.log(newValue)
        this.vditor.setValue(newValue);
        this.$emit('input', newValue);
      }
    },
    computed: {
      editorValue: {
        get() {
          return this.value;
        },
        set(val) {
          console.log(val)
          this.newValue = val;
        }
      }
    },
    methods: {
      onloadCallBack(url , name){
        this.vditor.insertValue(`![${name}](${url})`);
      }
    },
    mounted() {
      var that = this;
      this.vditor = new Vditor(this.editorId, {
        cdn: that.$tinymceUrl + '/vditor',
        height: 500,
        placeholder: '请输入内容',
        theme: 'classic',
        counter: {
          enable: true,
          type: 'markdown',
        },
        preview: {
          delay: 0,
          hljs: {
            style: 'monokai',
            lineNumber: true,
          },
        },
        tab: '\t',
        typewriterMode: true,
        toolbarConfig: {
          pin: true,
        },
        cache: {
          enable: false,
        },
        mode: 'sv',
        toolbar: [
          'emoji',
          'headings',
          'bold',
          'italic',
          'strike',
          'link',
          '|',
          'list',
          'ordered-list',
          'check',
          'outdent',
          'indent',
          '|',
          'quote',
          'line',
          'code',
          'inline-code',
          'insert-before',
          'insert-after',
          '|',
          'table',
          '|',
          'undo',
          'redo',
          '|',
          'edit-mode',
          'code-theme',
          'export',
          {
            name: 'more',
            toolbar: [
              'fullscreen',
              'both',
              'preview',
              'info',
              'help',
            ],
          },
        ],
        upload: {
          url: this.$apiUrl + '/util/upload/picFile', // 你的上传接口地址
          accept: 'image/jpeg,image/png,image/gif,image/jpg,image/bmp,.mp4', // 允许上传的图片格式
          max: 20 * 1024 * 1024, // 图片大小限制，单位为字节
          multiple: false, // 是否允许批量上传
          fieldName: 'file', // 上传字段名称
          headers: {
            'Content-Type': 'multipart/form-data',
            'authorization': this.$store.state.user ?  this.$store.state.user.token : null,
            'Accept-Language':'zh-CN',
          },
          filename(name) {
            // 文件名安全处理
            return name
              .replace(/[^(a-zA-Z0-9\u4e00-\u9fa5\.)]/g, '')
              .replace(/[\?\\/:|<>\*$$$$  $$ \$%\{\}@~]/g, '')
              .replace('/\\s/g', '');
          },
          handler(files) {
            // 自定义上传逻辑
            const formData = new FormData();
            formData.append('file', files[0]);
            that.postMultipartRequest('/util/upload/picFile', formData)
              .then(resp => {
                if (resp && resp.status == 200) {
                  var url = resp.data.result.url;
                  //callback(url, files[0].name);
                  that.onloadCallBack(url, files[0].name)

                }else {
                  console.error('上传失败1:', resp);
                }
              })
              .catch((error) => {
                console.error('上传失败2:', error);
              });
          },
        },
        //在   mounted   钩子中，为 Vditor 添加   input   事件监听器
        after: () => {
          this.vditor.setValue(this.value);
        },
        input:() => {
          const content = this.vditor.getValue()
          this.$emit('input', content); // 将值传递到父组件
        },

      });
    },
    beforeDestroy() {
      if (this.vditor) {
        this.vditor.destroy();
      }
    },
  };
</script>

<style scoped>
  /* 可以在这里添加一些样式 */
</style>
